import React, { useContext } from 'react';
import { SnackBarContext } from '../../Context/SnackBarContextProvider';
import { useDeclineQuizAssignmentMutation } from '../../services/SkillsManagement';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import { Button } from '@mui/material';
import MuiDialog from '../../SystemDesign/MuiDialog';

const DeclineAssignment = ({ assignmentId, onDeclined }) => {
  const { setInfoAlert, setOpenSnackBar } = useContext(SnackBarContext);
  const [declineAssignment, { isLoading }] = useDeclineQuizAssignmentMutation();

  const id = Number(assignmentId);
  if (!id) return null;

  const handleConfirmDecline = async () => {
    try {
      const res = await declineAssignment({ assignmentId: id }).unwrap();
      setInfoAlert({ severity: 'success', message: 'Assignment declined successfully.' });
      setOpenSnackBar(true);
      try { onDeclined?.(res?.data || res); } catch {}
      return true;
    } catch (error) {
      setInfoAlert({
        severity: 'error',
        message: error?.data?.message || error?.message || 'Failed to decline assignment.',
      });
      setOpenSnackBar(true);
      return false;
    }
  };

  const triggerButton = (
    <Button size="small" variant="outlined" color="error">
      Decline
    </Button>
  );

  const dialogContent = (
    <div>
      <p>Are you sure you want to decline this assignment?</p>
      <p>You will not be able to take this quiz unless it is reassigned.</p>
    </div>
  );

  return (
    <MuiDialog
      icon={<DoNotDisturbIcon />}
      triggerButton={triggerButton}
      title="Decline Assignment"
      subtitle={`You are about to decline assignment ${id}`}
      content={dialogContent}
      maxWidth="xs"
      existAction={true}
      actionTitle="Decline"
      actionFunction={handleConfirmDecline}
      isLoading={isLoading}
    />
  );
};

export default DeclineAssignment;